export class User {
  name: string = '';
  gmailid: string = '';
  img: string = '';
  email: string = '';
  accessKey: string = '';
  secretAccessKey: string = '';
}



// WEBPACK FOOTER //
// ./src/app/models/users.model.ts